import clsx from 'clsx'
import React from 'react'
import {size, toArray} from 'lodash'
import {connect} from 'react-redux'
import Box from '@mui/material/Box' 
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import {makeStyles} from 'external/material'

import UploadedFiles from 'uploads/UploadedFiles'
import UploadProgress from 'uploads/UploadProgress'
import {setUploadFile} from 'uploads/redux/actions'
import store from 'uploads/redux/store'

const useStyles = makeStyles(createStyles)

function testReset() {
  
  const resetUploads = () => (dispatch) => {      
    dispatch({
      type: 'RESET_UPLOADS'
    })
  }
  store.dispatch(resetUploads())
}

function testSave() {
  console.log('fileProgress',  store.getState().UploadFile.fileProgress)
}

function loadTestData() {
  const data = [{"name":"Teacher document.pdf","folder":"homeworks/00000000-4ff7-4e2a-bba9-da0f0e219bae/", "server":"https://api.edusystem.local/files"}]
  const loadUploads = () => (dispatch) => {      
    dispatch({
      type: 'LOAD_UPLOADS',
      payload: data
    })
  }
  store.dispatch(loadUploads())
}

function UploadFiles(props) {
    const {server, folder, setUploadFile, translate = a => a, buttonText, readOnly, downloadServer } = props;
    const classes = useStyles()    
    const handleAttachFile = e => {     
        setUploadFile(toArray(e.target.files).map(file => ({file, server, folder})))
        e.target.value = '' // to clear the current file
    }

    if(readOnly) {
      return(
        <Box className={classes.uploads}>
          {/* <Button onClick={loadTestData}>Test Load</Button> */}
          <UploadedFiles translate={translate} downloadServer={downloadServer} /> 
        </Box>
      )
    } 

    return (
      <Box className={classes.uploads}>
        {/* <Button onClick={testSave}>Test Save</Button>  */}         
        {/* <Button onClick={testReset}>Test Reset</Button>   */}
        {/* <Button onClick={loadTestData}>Test Load</Button> */}
          <Button  
              className={clsx(classes.root, 'button')}
              variant="contained"
              component="label"
              >
              <AddIcon fontSize={'small'} focusable={false} />
              {buttonText??'Upload'}
              <input type="file" multiple hidden onChange={handleAttachFile} />
          </Button>
          <UploadProgress translate={translate} downloadServer={downloadServer} />
      </Box>
    )
}

const mapDispatchToProps = dispatch => ({ 
  setUploadFile: files => dispatch(setUploadFile(files))
})

export default connect(null, mapDispatchToProps)(UploadFiles)
 

function createStyles(theme) {   
    return {
      uploads: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: '14px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        '& a': {
          color: '#639de2',
          textDecoration: 'none',
          cursor: 'pointer',
          position: 'relative',
          top: -7,
          '&:hover': {
            textDecoration: 'underline'
          }
        },
        '& span.MuiButton-label': {
          textTransform: 'capitalize',
          textAalign: 'left',
          justifyContent: 'flex-start'
        },
        '& .button': {
          textTransform: 'capitalize',
          color: '#639de2',
          fontWeight: '600',
          fontSize: '14pt',
          backgroundColor:'transparent',
          border: 'solid 1px #93c4ed',
          boxShadow: 'none',
          textAlign: 'left',
          padding: 8,
          margin: 0,
          "&:hover": {
            backgroundColor: "transparent"
          },
          "&:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
}
